<template>
    <b-modal ref="login-modal" id="modal-login" title="My Event Cafe" hide-footer>
      <b-form @submit.stop.prevent="SubmitLogin">
        <label for="feedback-user">{{ $t('emailAddress') }}</label>
        <b-input v-model="userId" :state="EmailValidation" id="feedback-user"></b-input>
        <b-form-invalid-feedback :state="EmailValidation">
          You must enter a valid email address.
        </b-form-invalid-feedback>
        <b-form-valid-feedback :state="EmailValidation">
        </b-form-valid-feedback>

        <label for="text-password">{{ $t('password') }}</label>
        <b-input v-model="password" type="password" :state="PasswordValidation" id="text-password" aria-describedby="password-help-block"></b-input>
        <div class="clearfix">
          <label class="text-danger" >{{ error }}</label>
        </div>
        <div class="w-100 mt-2 mb-0 clearfix">
          <p class="float-right ml-2">
            <b-button v-if="!busy" variant="success" type="submit" :disabled="!FormValidation">{{ $t('login') }}</b-button>
            <b-button v-if="busy" variant="secondary" type="submit" disabled>Logging in... <b-spinner small></b-spinner></b-button>
          </p>
          <p class="float-right"><button type="button" class="btn btn-secondary" @click="$bvModal.hide('modal-login')">{{ $t('close') }}</button></p>
          <router-link to="/password/forgot">{{ $t('registration.forgotPassword') }}?</router-link>
        </div>
      </b-form>
    </b-modal>
</template>

<script>
export default {
  name: 'LoginModal',
  data () {
    return {
      userId: '',
      password: '',
      error: '',
      busy: false
    }
  },
  computed: {
    EmailValidation () {
      return this.userId.length === 0 ? null
        : this.userId.length > 4 &&
        this.validEmail(this.userId)
    },
    PasswordValidation () {
      return this.password.length === 0 ? null : this.password.length > 4
    },
    FormValidation () {
      return this.EmailValidation && this.PasswordValidation
    },
    isLoggedIn () {
      return this.$store.getters.isLoggedIn
    },
    hasRegisterListener () {
      return this.$listeners && this.$listeners.registerRequested
    }
  },
  methods: {
    validEmail (email) {
      // eslint-disable-next-line
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email.trim())
    },
    SubmitLogin () {
      this.busy = true
      let userId = this.userId
      let password = this.password
      console.log('Attempting to Call Store Login: ' + userId)
      this.$store
        .dispatch('login', { email: userId, password })
        .then(() => {
          this.busy = false
          this.$refs['login-modal'].hide()
          this.$emit('loginFinished')
        })
        .catch(err => {
          this.busy = false
          console.log('ERROR:' + err)
          this.password = ''
          this.error = err.response.data
        })
    }
  }
}
</script>

<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
